<admin-page-simple-content
    [icon]="'logs'"
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Store: Webhook Logs'"
>
    <div class="content">
        @if (!webhookLogEnabled) {
                <div class="warning-message mat-elevation-z2">
                    <mat-icon color="warn">warning</mat-icon>
                    <span>Webhook logging is currently disabled.</span>
                    <span class="padding"></span>
                    <button (click)="enableWebhookLogging()" mat-stroked-button [disabled]="pageStatus === 'saving'">
                        Enable
                    </button>
                </div>
        }
        <div class="filters">
            <button (click)="reload()" mat-stroked-button>
                <mat-icon>refresh</mat-icon>
                Reload
            </button>
            <mat-form-field class="date-range">
                <mat-label>Date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input (dateChange)="updateFilter()" [(ngModel)]="filter.startDate" matStartDate
                           placeholder="Start date">
                    <input (dateChange)="updateFilter()" [(ngModel)]="filter.endDate" matEndDate placeholder="End date">
                </mat-date-range-input>
                <span matIconSuffix class="clear-button">
                    <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                    <button (click)="clearDate()" [disabled]="!filter.startDate && !filter.endDate"
                            mat-icon-button>
                        <mat-icon>clear</mat-icon>
                    </button>
                </span>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>

        <div class="search">
            <mat-form-field>
                <mat-label>Highlight Matching Logs</mat-label>
                <input matInput [(ngModel)]="searchText">
                <mat-hint>Highlight log with header or body containing this text</mat-hint>
            </mat-form-field>
        </div>

        <table (matSortChange)="updateSort($event)" [dataSource]="webhookLogs" [matSortActive]="'sentDateUtc'"
               [matSortDirection]="filter.dateOrdering"
               class="webhook-log-table mat-elevation-z4" mat-table matSort>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                <mat-cell *matCellDef="let webhookLog">
                    <button (click)="showLog(webhookLog)" mat-icon-button>
                        <mat-icon>code</mat-icon>
                    </button>
                    <button (click)="showLogDetails(webhookLog)" mat-icon-button>
                        <mat-icon>open_in_full</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>
            <!-- URL Column -->
            <ng-container matColumnDef="url">
                <mat-header-cell *matHeaderCellDef>Url</mat-header-cell>
                <mat-cell *matCellDef="let webhookLog">
                    <span class="url" [class.match]="isMatchingSearch($storeWebhookLog(webhookLog))">
                        {{ $storeWebhookLog(webhookLog).url }}
                    </span>
                </mat-cell>
            </ng-container>
            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                <mat-cell *matCellDef="let webhookLog">
                    <span class="status status-{{ $storeWebhookLog(webhookLog).statusCode / 100 }}">
                        {{ $storeWebhookLog(webhookLog).statusCode }}
                    </span>
                </mat-cell>
            </ng-container>
            <!-- Date Created Column -->
            <ng-container matColumnDef="sentDateUtc">
                <mat-header-cell *matHeaderCellDef [disableClear]="true" mat-sort-header>Date Created</mat-header-cell>
                <mat-cell *matCellDef="let line">
                    <div>
                        <div class="text-truncate">
                            {{ $storeWebhookLog(line).sentDateUtc | date: "mediumDate" }}
                            {{ $storeWebhookLog(line).sentDateUtc | date: "HH:mm:ss" }}

                        </div>
                        <div class="text-truncate">
                            <span>({{ $storeWebhookLog(line).sentDateUtc | fromNow }})</span>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row
                *matRowDef="let line; columns: displayedColumns"
                class="order"
            >
            </mat-row>
        </table>

        <div class="paginator">
            <mat-form-field class="result-per-page">
                <mat-label>Result per page</mat-label>
                <mat-select (selectionChange)="updateFilter()" [(ngModel)]="resultPerPage">
                    <mat-option [value]="10">10</mat-option>
                    <mat-option [value]="20">20</mat-option>
                    <mat-option [value]="50">50</mat-option>
                    <mat-option [value]="200">200</mat-option>
                </mat-select>
            </mat-form-field>
            <span>Page: {{ page + 1 }}</span>
            <button (click)="loadPage(0)" [disabled]="page === 0" mat-icon-button>
                <mat-icon>first_page</mat-icon>
            </button>
            <button (click)="loadPage(page - 1)" [disabled]="page === 0" mat-icon-button>
                <mat-icon>navigate_before</mat-icon>
            </button>
            <button (click)="loadPage(page + 1)" [disabled]="!hasNextPage" mat-icon-button>
                <mat-icon>navigate_next</mat-icon>
            </button>
        </div>

    </div>

</admin-page-simple-content>
